import { isValidPhoneNumber, parsePhoneNumber } from "libphonenumber-js/max";

export const EMAIL = [
  (v) => !!v || "Email address is required",
  (v) => /\S+@\S+\.\S+/.test(v) || "Sorry! Invalid email address"
];
export const PIN = [
  (v) => !!v || "Pincode is required",
  (v) => /\d{6}/.test(v) || "Sorry! Invalid Pincode"
];

export const NAME = [
  (v) => !!v || "Name is required",
  (v) =>
    /[a-zA-Z0-9]/.test(v) || "Name must contain at least one valid character"
];
export const AMOUNT = [
  (v) => !!v || "Amount is required",
  (v) => v > 0 || "Amount must be greater than 0"
];

export const AMOUNT_OPTIONAL = [
  (v) => !v || v > 0 || "Amount must be greater than 0"
];

export const RULES = [EMAIL, PIN, NAME, AMOUNT];

export const getPhoneRules = (phone, iso, allowLandline) => {
  return [
    (v) => !!v || "Mobile Number is required",
    (v) => {
      if (!isValidPhoneNumber(phone, iso)) {
        return "Sorry! Invalid mobile number";
      }

      if (!allowLandline) {
        const numberType = parsePhoneNumber(phone)?.getType();
        if (numberType === "FIXED_LINE") {
          return "Please enter a valid mobile number";
        }
      }

      return true;
    }
  ];
};
